import { Navigate, useRoutes } from 'react-router-dom';
import { userAfterLoginRoutes } from '@src/domains/user-after-login/routes';
import { companyManagmentDashboardRoutes } from '@src/domains/company-dashboard/routes';

import { helpRoutes } from './pages/help';
import { mainRoutes } from './sections/main';
import { authRoutes } from './sections/auth';
import { landingRoutes } from './sections/landing';
import { dashboardRoutes } from './pages/dashboard';
import { userProfileRoutes } from './pages/user-profile';
import { reportRoutes } from '../domains/business/reports/routes';
import { userAccountRoutes } from '../domains/user-account/routes';
import { companyRoutes } from '../domains/business/company/routes';
import { supportTicketRoutes } from '../domains/support-ticket/routes';
import { companyPartnerRoutes } from '../domains/business/company-partner/routes';
import { companyProjectRoutes } from '../domains/business/company-project/routes';
import { companyProjectActionRoutes } from '../domains/business/company-project-action/routes';
import { CompanyProjectCategoryRoutes } from '../domains/business/company-project-category/routes';
// --------------------------------------W--------------------------------

export default function Router() {
  return useRoutes([
    // Landing routes
    ...landingRoutes,
    // Auth routes
    ...authRoutes,
    // Dashboard Routes
    ...dashboardRoutes,
    // Main routes
    ...mainRoutes,
    // User After Login
    ...userAfterLoginRoutes,
    // User Profile Routes
    ...userProfileRoutes,
    // User Account Routes
    ...userAccountRoutes,
    // Company Routes
    ...companyRoutes,
    // Support Ticket Routes
    ...supportTicketRoutes,
    // Company Partner Routes,
    ...companyPartnerRoutes,
    // Company Project Routes
    ...companyProjectRoutes,
    // Company Project Action Routes
    ...companyProjectActionRoutes,
    // Company Project Category Routes
    ...CompanyProjectCategoryRoutes,
    // company Dashboard Routes,
    ...companyManagmentDashboardRoutes,
    // Report Builder Routes
    ...reportRoutes,
    // Help routes
    ...helpRoutes,
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
